export default {
  name: "Overseas Agent Assignments",
  meta: {
    icon: "directions_boat",
    expanded: true,
    auth: true,
  },
  departmentName: "Overseas Agent Assignments",
  finalPagePermision: "",
  children: [
    {
      name: "Credit/Debit Note Approval",
      path: "/creditDebitNote/ApprovalList",
      permissionName: "CRDR_Approval",
      keywords: [
        "Credit/Debit Note Approval",
        "Overseas Fcl Assignment",
        "FCL",
        "LCL",
        "Overseas Fcl Con Assignment",
        "Overseas Fcl Import Assignment",
        "Overseas Agent Assignments",
        "Other Overseas Assignment",
        "Overseas Agent SOA",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/creditDebitNote/ApprovalList.vue"),
      finalPagePermision: "CRDR_Approval",
    },
    {
      name: "Overseas Fcl Assignment",
      path: "/overseas/Viewfright",
      permissionName: "Sea Export",
      keywords: [
        "Overseas Fcl Assignment",
        "FCL",
        "LCL",
        "FCL/LCL Details ",
        "Overseas Agent Assignments",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/freightForwarding/overSeasFreight.vue"),
      finalPagePermision: "FCL Export",
      // finalPagePermision: "Sea Export",
    },
    // {
    //   name: "Overseas Fcl Assignment Node",
    //   path: "/overseas/ViewfrightNode",
    //   permissionName: "Sea Export",
    //   keywords: [
    //     "Overseas Fcl Assignment Node",
    //     "FCL",
    //     "LCL",
    //     "FCL/LCL Details ",
    //     "Overseas Agent Assignments",
    //   ],
    //   meta: {
    //     icon: "directions_boat",
    //     auth: true,
    //   },
    //   component: require("../component/freightForwarding/overSeasFreightNode.vue"),
    //   finalPagePermision: "FCL Export",
    //   // finalPagePermision: "Sea Export",
    // },
    {
      name: "Overseas Fcl Con Assignment",
      path: "/overseas/ViewfclCon",
      permissionName: "Sea Export",
      keywords: [
        "Overseas Fcl Assignment",
        "FCL",
        "LCL",
        "Overseas Fcl Con Assignment",
        "Overseas Agent Assignments",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/freightForwarding/overSeasFclCon.vue"),
      finalPagePermision: "FCL Con Export",
      // finalPagePermision: "Sea Export",
    },
    {
      name: "Overseas Fcl Import Assignment",
      path: "/overseas/ViewfrightIMP",
      permissionName: "Sea Export",
      keywords: [
        "Overseas Fcl Assignment",
        "FCL",
        "LCL",
        "Overseas Fcl Con Assignment",
        "Overseas Fcl Import Assignment",
        "Overseas Agent Assignments",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/seaImport/overseasFreightImp.vue"),
      finalPagePermision: "FCL Import",
      // finalPagePermision: "Sea Export",
    },
    {
      name: "Other Overseas Assignment",
      path: "/overseas/OtherCommonOverseas",
      permissionName: "Other_Overseas",
      keywords: [
        "Overseas Fcl Assignment",
        "FCL",
        "LCL",
        "Overseas Fcl Con Assignment",
        "Overseas Fcl Import Assignment",
        "Overseas Agent Assignments",
        "Other Overseas Assignment",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/Overseas/otherCommonOverseas.vue"),
      finalPagePermision: "Other_Overseas", //
    },

    {
      name: "Overseas Agent SOA",
      path: "/overseas/OverseasAgentSOA",
      permissionName: "Agent_SOA",
      keywords: [
        "Overseas Fcl Assignment",
        "FCL",
        "LCL",
        "Overseas Fcl Con Assignment",
        "Overseas Fcl Import Assignment",
        "Overseas Agent Assignments",
        "Other Overseas Assignment",
        "Overseas Agent SOA",
      ],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/Overseas/overseasAgentSoa.vue"),
      finalPagePermision: "Agent_SOA",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/sidebar/overSeasAssign.js